import('../../static/mdb-addons/mdb-lightbox-ui.html').then(lightboxUi => $('#mdb-lightbox-ui').html(lightboxUi));
